import { render, staticRenderFns } from "./ProductGroup.vue?vue&type=template&id=a3d57d98&scoped=true"
import script from "./ProductGroup.vue?vue&type=script&lang=js"
export * from "./ProductGroup.vue?vue&type=script&lang=js"
import style0 from "./ProductGroup.vue?vue&type=style&index=0&id=a3d57d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d57d98",
  null
  
)

export default component.exports